export default __webpack_public_path__ + "static/media/q2_02.ad9b4c59.png";